const DEFAULT_DOWNLOAD_FILE_NAME = 'attachment';

type DownloadAsFileOptions = {
  fallbackToNewTab?: boolean;
};

export async function downloadUrlAsFile(
  url: string,
  fileName?: string | null,
  options: DownloadAsFileOptions = {}
): Promise<boolean> {
  const { fallbackToNewTab = true } = options;

  try {
    const response = await fetch(url);
    if (!response.ok) {
      throw new Error(`Download failed: ${response.status} ${response.statusText}`);
    }

    const blob = await response.blob();
    const objectUrl = URL.createObjectURL(blob);

    const link = document.createElement('a');
    link.href = objectUrl;
    link.download = String(fileName || '').trim() || DEFAULT_DOWNLOAD_FILE_NAME;
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);

    window.setTimeout(() => URL.revokeObjectURL(objectUrl), 1000);
    return true;
  } catch (error) {
    if (fallbackToNewTab) {
      window.open(url, '_blank', 'noopener,noreferrer');
    }
    return false;
  }
}
